const UID_REGEX = /^[A-Za-z0-9-_.~]*$/;

export default UID_REGEX;
